import { render, staticRenderFns } from "./ChannelsTabs.vue?vue&type=template&id=50f7388a&scoped=true&"
import script from "./ChannelsTabs.vue?vue&type=script&lang=js&"
export * from "./ChannelsTabs.vue?vue&type=script&lang=js&"
import style0 from "./ChannelsTabs.vue?vue&type=style&index=0&id=50f7388a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f7388a",
  null
  
)

export default component.exports